import { render, staticRenderFns } from "./TendenciaOnline.vue?vue&type=template&id=b282f63e&"
import script from "./TendenciaOnline.vue?vue&type=script&lang=js&"
export * from "./TendenciaOnline.vue?vue&type=script&lang=js&"
import style0 from "./TendenciaOnline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports